import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { ReportLinkCard } from 'modules/components/layer05';
import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { SaveClientReportLinkModal } from 'modules/components/layer17';


type IReportLink = {
  id: string;
  notesForClient: string;
  url: string;
};

export type ClientReportLinkCardProps = {
  id: string;
  links: IReportLink[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportLinkCardProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>{
      isVisible && (
        <SaveClientReportLinkModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )
    }
    <ActivityDetailSectionCardBaseLayout.FC
      title='Links'
      subTitle='Add Links for the client to view'
      actionButton={{
        onClick: () => setIsVisible(() => true),
        text: 'Add Link'
      }}
      editActionButton={null}
      boxProps={{
        flex: '1 1 0'
      }}
      isEmpty={
        props.links.length < 1
          ? true
          : false
      }
    >
      <Stack
        direction='column'
        rowGap='1rem'
      >
        {props.links.map((node) => (
          <ReportLinkCard.FC
            key={node.id}
            id={node.id}
            handleDelete={() => {}}
            name={node.notesForClient}
            url={node.url}
          />
        ))}
      </Stack>
    </ActivityDetailSectionCardBaseLayout.FC>
    </>
  );
};
